export default {
  MODAL_OPENED: 'Modal opened',
  MODAL_CLOSED: 'Modal closed'
};
